<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app temporary>
      <v-list shaped nav >
        <v-list-item class="mb-3 px-2">
          <v-list-item-icon class="text-center">
            <v-icon large class="mx-auto text-center"> mdi-account-circle </v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-subtitle> Developer </v-list-item-subtitle>
            <v-list-item-title>
              <a href="https://instagram.com/salmanul.faris1" target="_blank"
                >Salmanul Faris</a
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-subheader>Menu</v-subheader>
        <v-list-item to="/">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="h6"> Home </v-list-item-title>
        </v-list-item>

        <v-list-item to="/feedback" >
          <v-list-item-icon>
            <v-icon>mdi-message</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="h6"> Leave a feedback </v-list-item-title>
        </v-list-item>

        <v-list-item to="/notifications">
          <v-list-item-icon>
            <v-icon>mdi-bell</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="h6"> My Notifications </v-list-item-title>
        </v-list-item>

        <v-divider></v-divider>
        <!-- <v-list-item @click="hardReload()">
          <v-list-item-icon>
            <v-icon color="primary">mdi-cellphone-arrow-down</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="primary--text">
            Update Website
          </v-list-item-title>
        </v-list-item> -->
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app elevation="0" color="primary" dark>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
        <router-link to="/" class="text-decoration-none white--text">

      <v-toolbar-title>Vaccine Notifier</v-toolbar-title>
        </router-link>
      <v-spacer></v-spacer>
      <h3>By <span class="font-italic"> Acuntant.com </span></h3>
    </v-app-bar>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>
<script>
export default {
  data: () => ({
    drawer: false,
  }),
  methods: {
    hardReload() {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .register("/firebase-messaging-sw.js", { scope: "sw-test" })
          .then(function (registration) {
            // registration worked
            console.log("Registration succeeded.");
            registration.update();
            window.location.reload();
            // this.router.push('/');
          })
          .catch(function (error) {
            // registration failed
            console.log("Registration failed with " + error);
          });
      }
    },
  },
};
</script>


